import { render, staticRenderFns } from "./preview03.vue?vue&type=template&id=2974a830&scoped=true"
import script from "./preview03.vue?vue&type=script&lang=js"
export * from "./preview03.vue?vue&type=script&lang=js"
import style0 from "./preview03.vue?vue&type=style&index=0&id=2974a830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2974a830",
  null
  
)

export default component.exports